import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { HandleSearchInput } from "../components/HandleSearchInput";
import { t } from "../i18n";
import { Clipboard, ChevronLeft } from "lucide-react";
import { extractHandleFromInstagramUrl } from "@lib/utils";

export function AppAddTargetPage() {
  const navigate = useNavigate();
  const [clipboardHandle, setClipboardHandle] = useState<string | null>(null);
  const [initialValue, setInitialValue] = useState("");

  useEffect(() => {
    let cancelled = false;

    async function checkClipboard() {
      try {
        if (!navigator.clipboard?.readText) return;
        const text = await navigator.clipboard.readText();
        const handle = extractHandleFromInstagramUrl(text);
        if (!cancelled) setClipboardHandle(handle);
      } catch {
        // Browser clipboard access can be blocked until user gesture.
      }
    }

    void checkClipboard();
    window.addEventListener("focus", checkClipboard);
    return () => {
      cancelled = true;
      window.removeEventListener("focus", checkClipboard);
    };
  }, []);

  const handleSubmit = (handle: string) => {
    navigate(`/app/add-target/preview?handle=${encodeURIComponent(handle)}`);
  };

  return (
    <div className="app-page app-add-target-page">
      <button onClick={() => navigate("/app")} className="app-back-button">
        <ChevronLeft size={34} />
        <span>{t("commonBack")}</span>
      </button>

      <section className="app-target-entry-card">
        <div className="app-page-header">
          <div>
            <h1>{t("onboardingTargetTitle")}</h1>
            <p className="app-target-entry-copy">{t("addTargetSubtitle")}</p>
          </div>
        </div>

        {clipboardHandle && !initialValue && (
          <button
            type="button"
            className="app-clipboard-chip"
            onClick={() => {
              setInitialValue(clipboardHandle);
              setClipboardHandle(null);
            }}
          >
            <Clipboard size={15} />
            {t("addTargetClipboardPaste", { handle: clipboardHandle })}
          </button>
        )}

        <HandleSearchInput
          autoFocus
          large
          initialValue={initialValue}
          isLoading={false}
          buttonLabel={t("addTargetModalTitle")}
          onSearch={(handle) => void handleSubmit(handle)}
        />
      </section>
    </div>
  );
}
